import {
    Typography, CardHeader, Card, CardContent, TextField,
    Stack
} from "@mui/material";
import { Grid } from "@material-ui/core";
import { forwardRef, useCallback, useImperativeHandle, useMemo, useRef } from "react";
import React from "react";
import MergeTagWidget from 'components/broadcast/components/broadcast-page/merge-tags';
import { EmojiPickerButton } from 'common/components/buttons';
import UrlShortenerWidget from 'components/broadcast/components/broadcast-page/url-shortener-widget';
import { AutomationConstant } from '../../api/automation-constants';
import { FormikProps, useFormik } from "formik";
import * as Yup from "yup";
import { handleAddUrlShortner, handleEmojiSelect, OpenMergeTagsWindow, MergeTagConstants } from "common/utils/merge-tag-helper";

const commonTextFieldProps = {
    fullWidth: true,
    variant: "outlined" as const,
};

const fieldNames = {
    textMessage: "textMessage",
    isText: "isText",
} as const;

interface TextSettingsProps {
    initialValues?: any;
}

const TextSettings = React.memo(
    forwardRef<FormikProps<any>, TextSettingsProps>((props: TextSettingsProps, ref) => {
        const { initialValues } = props;
        const textMessageRef = useRef<HTMLInputElement>(null);

        const validationSchema = useMemo(() => Yup.object<any>().shape<any>({
            isText: Yup.boolean(),
            textMessage: Yup.string().nullable().when(fieldNames.isText, {
                is: true,
                then: (schema: any) => schema.required("Text message is required")
                    .max(AutomationConstant.textMessageLimit, AutomationConstant.MaximumLengthAllowed(AutomationConstant.textMessageLimit)),
            }),
        }), []);

        const formik = useFormik({
            initialValues: initialValues,
            validationSchema,
            enableReinitialize: true,
            onSubmit: (values) => {
            },
        });

        useImperativeHandle(ref, () => formik);

        const handleMessageMergeTag = useCallback(
            (body: string) => {
                OpenMergeTagsWindow(textMessageRef, body, fieldNames.textMessage, formik.setFieldValue, formik.setFieldError, AutomationConstant.textMessageLimit);
            },
            [formik.setFieldValue, formik.setFieldError]
        );

        const handleMessageEmoji = useCallback(
            (value: string) => {
                handleEmojiSelect(textMessageRef, value, fieldNames.textMessage, formik.setFieldValue, formik.setFieldError, AutomationConstant.textMessageLimit)
            },
            [formik.setFieldValue, formik.setFieldError]);

        const handleMessageUrlShortner = useCallback(
            (body: string) => {
                handleAddUrlShortner(textMessageRef, body, fieldNames.textMessage, formik.setFieldValue, formik.setFieldError, AutomationConstant.textMessageLimit)
            },
            [formik.setFieldValue, formik.setFieldError]);

        //  console.log("Text Settings", formik.values.isText);
        return (
            <Card variant="outlined" style={{ borderColor: '#ccc', marginTop: "10px" }}>
                <CardHeader
                    title={<Typography variant="subtitle1">Text</Typography>}
                />

                <CardContent style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    <TextField
                        inputRef={textMessageRef}
                        {...commonTextFieldProps}
                        multiline
                        rows={3}
                        id="text-message"
                        name="textMessage"
                        value={formik.values.textMessage}
                        label="Message"
                        margin="dense"
                        onChange={formik.handleChange}
                        error={!!formik.errors.textMessage}
                        helperText={formik.errors.textMessage}
                    />
                    <Grid item container spacing={1} style={{ marginLeft: "1px" }}>
                        <MergeTagWidget
                            refScreen={MergeTagConstants.Automation}
                            disabled={false}
                            onClick={handleMessageMergeTag}
                        />
                        <EmojiPickerButton
                            onSelect={handleMessageEmoji}
                            disabled={false}
                        />
                        <UrlShortenerWidget
                            onClick={handleMessageUrlShortner}
                            disabled={false}
                        />
                    </Grid>
                </CardContent>

            </Card>
        );
    })
);


export default TextSettings;